import { queue } from 'd3'

export default () => (dispatch, getState) => {

  const { token, wtRegion, wtRegionCCYOptions, clientEmail }  = getState()

  const makeTheCall = (url, callback) => {
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token &&
          `Token ${token}`,
      }
    })
    .then(d => d.json())
    .then(callback)
    .catch(error => {
      console.error(error);
    })
  }

  wtRegionCCYOptions[wtRegion]
    .reduce((t,v) => 
      t.defer(
        makeTheCall, 
        `${process.env.REACT_APP_API_URL}/benchmarks/all/?wtRegion=${wtRegion}&entityCCY=${v.value}&clientEmail=${clientEmail}`
      )
    , queue())
    .awaitAll(function(response){
      if(response.benchmarks){
        dispatch({ type: 'LOAD_BENCHMARKS', benchmarks: response.benchmarks })      
      }
    })
};


// WEBPACK FOOTER //
// ./src/actions/query-api/benchmarks.js